import { initializeApp } from 'firebase/app';
import { getToken, type MessagePayload } from 'firebase/messaging';
import { UserService } from '.';
import { LocalStorageUtils } from '@/utils';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

const isWebView = () => {
  const ua = navigator.userAgent || '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Boolean((window as any).ReactNativeWebView) ||
    /wv|WebView/i.test(ua) ||
    (/iPhone|iPad|iPod/i.test(ua) && !/Safari/i.test(ua));
};

const canUseMessaging = async () => {
  if (typeof window === 'undefined') return false;
  if (isWebView()) return false;
  if (!('serviceWorker' in navigator)) return false;

  const { isSupported } = await import('firebase/messaging');
  return await isSupported();
};

const getMessagingSafe = async () => {
  if (!(await canUseMessaging())) return null;
  const { getMessaging } = await import('firebase/messaging');
  return getMessaging(app);
};

export const requestForToken = async () => {
  const messaging = await getMessagingSafe();
  if (!messaging) return;

  return getToken(messaging, { vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY })
    .then(async currentToken => {
      if (currentToken && currentToken !== LocalStorageUtils.getFcmToken()) {
        console.log('current token for client: ', currentToken);
        // Send the token to your server and update the UI if necessary
        // ...
        const userId = LocalStorageUtils.getUserId();
        const status = await UserService.registerFCMToken(currentToken, userId);
        if (status) {
          LocalStorageUtils.saveFcmToken(currentToken);
        }
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
        // ...
      }
    })
    .catch(err => {
      console.log('An error occurred while retrieving token. ', err);
      // ...
    });
};

export const onMessageListener = async (callback: (payload: MessagePayload) => void) => {
  const messaging = await getMessagingSafe();
  if (!messaging) return () => {};

  const { onMessage } = await import('firebase/messaging');
  return onMessage(messaging, payload => callback(payload));
};
